export const AUTH_USERS_SET = 'AUTH_USERS_SET'
export const AUTH_USERS_FETCHING = 'AUTH_USERS_FETCHING'
export const AUTH_CURRENT_USER_FETCHING = 'AUTH_CURRENT_USER_FETCHING'
export const AUTH_CURRENT_USER_SET = 'AUTH_CURRENT_USER_SET'
export const AUTH_LOGIN_IN_PROGRESS = 'AUTH_LOGIN_IN_PROGRESS'
export const AUTH_PASSWORD_RECOVERY_IN_PROGRESS =
  'AUTH_PASSWORD_RECOVERY_IN_PROGRESS'
export const AUTH_CHECKED = 'AUTH_CHECKED'
